import { orange, pink, red } from '@material-ui/core/colors';
import { makeStyles, Theme } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme: Theme) => ({
  title: {
    flexGrow: 1,
    margin: theme.spacing(1),
  },
  textBox: {
    marginBottom: theme.spacing(3),
    fontSize: 14,
    color: 'rgb(0 0 0 / 54%)',
  },
  fixedHeight: {
    height: 240,
  },
  margin: {
    margin: theme.spacing(1),
  },
  search: {
    //margin: theme.spacing(2),
    width: '50%',
  },
  noBorder: {
    border: 'none',
  },
  box: {
    // marginBottom: theme.spacing(2),
    width: '100%',
    borderBottom: '1px solid rgba(224, 224, 224, 1)',
    // paddingTop: theme.spacing(2),
  },
  headerBtn: {
    boxShadow: 'none',
    textTransform: 'none',
    lineHeight: '36px',
    padding: `0 ${theme.spacing(3)}px`,
  },
  dataGrid: {
    width: '100%',
    '& .MuiDataGrid-root .MuiDataGrid-row.Mui-selected ': {},
    '& .MuiDataGrid-root .MuiDataGrid-row': {
      '&:hover': {
        backgroundColor: 'rgba(255, 80, 95, 0.04)',
      },
    },
    '& .row-background-error': {
      backgroundColor: red[50],
      '&:hover': {
        backgroundColor: red[100],
      },
    },
    '& .row-background-alert': {
      backgroundColor: pink[50],
      '&:hover': {
        backgroundColor: pink[100],
      },
    },
    '& .row-background-transaction': {
      backgroundColor: 'white',
      '&:hover': {
        backgroundColor: 'rgba(255, 80, 95, 0.04)',
      },
    },
    '& .cell-text-color-error': {
      color: pink[700],
    },
    '& .cell-text-color-alert': {
      color: orange[700],
    },
    '& .cell-text-color-transaction': {
      color: 'black',
      fontWeight: '500',
      textTransform: 'capitalize',
    },
    '& .MuiDataGrid-colCellTitle': {
      color: 'black',
      fontWeight: '700',
      textTransform: 'capitalize',
    },
  },
}));
